import { TablePage} from 'src/views/sco-admin/CountryCode'
import pathMap from 'src/paths/pathMap'


class SCOAdminCountryCodeRoute {
    getConfigurations() {
        return [
            {
                exact: true,
                path: pathMap.SCO_ADMIN_COUNTRY_CODE_LIST_VIEW,
                component: TablePage
            }
        ]
    }
}

export default SCOAdminCountryCodeRoute